import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  De_generateGeneralAttestationDocumentInput,
  useDeGenerateGeneralAttestationDocumentMutation as useDeGenerateGeneralAttestationDocumentMutationType,
} from "@/modules/patients/detail/general-attestation/de/services/__generated__/useDeGenerateGeneralAttestationDocumentMutation.graphql"

const mutation = graphql`
  mutation useDeGenerateGeneralAttestationDocumentMutation($input: De_generateGeneralAttestationDocumentInput!) {
    de_generateGeneralAttestationDocument(input: $input) {
      de_GeneralAttestation {
        id
        fileId
        ...deGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeGenerateGeneralAttestationDocumentMutationType>, "variables"> & {
  params: De_generateGeneralAttestationDocumentInput
}

const useDeGenerateGeneralAttestationDocumentMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeGenerateGeneralAttestationDocumentMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: config.params,
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeGenerateGeneralAttestationDocumentMutation }
